import React from 'react';
import PropTypes from 'prop-types';
import Button from '@/components/Button';
import classnames from 'classnames';

import './style.css';

function GetStartedFreeAccount({ visible, beaconIndex, onButtonFocus }) {
  return (
    <div
      data-index={beaconIndex}
      className={classnames('section', 'getstarted', {
        'section--visible': visible,
      })}
    >
      <div /* BEACON */ data-index={beaconIndex} className="beacon" />
      <div className="sticky-content-wrapper pointer-events">
        <div className="col">
          <h1 className="fade-in section__header">
            Get started today
            <br />
            with a free account
          </h1>

          <p className="fade-in td1 section__text">
            Create as many 'lifelines' as you wish. To remember who have passed.
          </p>
          <p className="fade-in td1 section__text">
            Start building your own lifeline to tell the story of your life so
            far.
          </p>
          <p className="fade-in td1 section__text">
            Keep your lifelines to view whenever you want.
          </p>
          <div className="buttons-wrapper fade-in td2">
            <Button
              size="large"
              variant="tertiary"
              to="/pricing"
              onFocus={() => {
                onButtonFocus(beaconIndex);
              }}
            >
              Sign up for free today
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

GetStartedFreeAccount.propTypes = {
  visible: PropTypes.bool.isRequired,
  beaconIndex: PropTypes.number.isRequired,
};

export default GetStartedFreeAccount;
